/* prenom-3d.js — configurateur « Prénom 3D en relief » (Hakaiki Print, Shopify)
 *
 * Port du prototype generateur_hakaiki.html v29 vers une section de thème Dawn.
 * Aperçu SVG en direct ; la config part dans le panier en propriétés de ligne,
 * le moteur OpenSCAD (roroserveur ~/name3d/) génère le STL à la commande.
 * Le fichier 3D ne sort jamais côté client.
 *
 * Changements vs v29 :
 *  - plus de rotation du prénom (le moteur ne la produit pas -> on ne la montre pas)
 *  - style d'écriture par défaut : Dancing Script (choix Hiro 2026-09-07)
 *  - les 3 boutons de style affichent le prénom saisi
 *  - validation avant ajout au panier (prénom + 3 mots du décor)
 *  - remplit les <input hidden name="properties[...]"> du formulaire Dawn
 */
(function () {
  'use strict';

  function init(root) {
    var $ = function (s) { return root.querySelector(s); };
    var PRICE = parseInt(root.getAttribute('data-price') || '4500', 10);
    var SIZEL = root.getAttribute('data-size-label') || '16 cm · 30 mm';
    var state = {
      name: root.getAttribute('data-default-name') || 'Tauanati',
      script: root.getAttribute('data-default-script') || 'Dancing',
      letter: '#F4F1E9', nameCol: '#1B1B1B',   // initiale blanche (base UV), prénom noir
      view: '2d', pn: 1, dx: 0, dy: 0, kw: ''
    };
    var SCRIPT_LABEL = { GrandHotel: 'Signature (Grand Hotel)', Cookie: 'Ronde (Cookie)', Dancing: 'Manuscrite (Dancing Script)' };

    var svg = $('.p3d-svg'), gI = $('.p3d-initial'), gN = $('.p3d-name'),
        shadow = $('.p3d-shadow'), depthI = $('.p3d-depthI'), depthN = $('.p3d-depthN'),
        clipT = $('.p3d-clipT'), decorL = $('.p3d-decorL'), handles = $('.p3d-handles');

    function fmt(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    function initialOf(s) { s = (s || '').trim(); return s ? s[0].toUpperCase() : ''; }
    function sideColor(hex) {
      hex = hex.replace('#', '');
      var r = parseInt(hex.substr(0, 2), 16), g = parseInt(hex.substr(2, 2), 16), b = parseInt(hex.substr(4, 2), 16);
      var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      if (lum < 0.45) { var f = 0.34; return 'rgb(' + Math.round(r + (255 - r) * f) + ',' + Math.round(g + (255 - g) * f) + ',' + Math.round(b + (255 - b) * f) + ')'; }
      return 'rgb(' + Math.round(r * 0.6) + ',' + Math.round(g * 0.6) + ',' + Math.round(b * 0.6) + ')';
    }

    /* ---------- contrôles ---------- */
    function segWire(sel, attr, key, after) {
      var el = $(sel); if (!el) return;
      el.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        state[key] = b.getAttribute(attr);
        [].forEach.call(el.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); if (after) after(); layout();
      });
    }
    segWire('.p3d-scripts', 'data-script', 'script');
    segWire('.p3d-view', 'data-view', 'view', function () {
      var t = $('.p3d-stagetag'); if (t) t.textContent = state.view === '3d' ? 'Rendu 3D' : 'Aperçu à plat';
    });
    $('.p3d-kw').addEventListener('input', function (e) { state.kw = e.target.value; syncForm(); });
    $('.p3d-input').addEventListener('input', function (e) { state.name = e.target.value; layout(); });
    var reset = $('.p3d-reset');
    if (reset) reset.addEventListener('click', function () { state.dx = 0; state.dy = 0; state.pn = 1; layout(); });

    /* ---------- géométrie de l'aperçu ---------- */
    var FLOOR = 372, CX = 300, VBW = 600;
    // Police de l'initiale par lettre — identique au moteur OpenSCAD de prod.
    //   A H K T -> Alfa Slab One · C G O Q -> Zilla Slab Bold · J U S -> Coustard Black
    //   V -> Eczar · reste Playfair Display Black
    var FAM = { A: ['AlfaT', 400], C: ['ZillaR', 700], G: ['ZillaR', 700], H: ['AlfaT', 400], J: ['CoustardJU', 900], K: ['AlfaT', 400],
                O: ['ZillaR', 700], Q: ['ZillaR', 700], S: ['CoustardJU', 900], T: ['AlfaT', 400], U: ['CoustardJU', 900], V: ['EczarV', 800] };
    function famFor(ch) { return FAM[ch] || ['PF', 900]; }
    // Pose du prénom : up = centre du prénom en fraction de la hauteur d'ENCRE de la
    // lettre, wf = largeur max en fraction de sa largeur. T : posé sur la barre haute.
    var POSE = { T: { up: 0.844, wf: 0.90 } };
    function poseFor(ch) { return POSE[ch] || { up: 0.38, wf: 1.00 }; }
    // Coupe au pied (fraction de l'encre) pour que la lettre tienne debout seule.
    var MEP = { B: 0.022, C: 0.047, D: 0.031, G: 0.034, J: 0.069, O: 0.028, Q: 0.078, R: 0.041, S: 0.028, U: 0.025, V: 0.041 };
    var W_OF = { PF: 900, AlfaT: 400, ZillaR: 700, CoustardJU: 900, EczarV: 800 };
    var FONTS_OK = false, INK = {};

    // Prénom avec sa capitale (et après un tiret : Marie-Claire), pas après une
    // apostrophe : les prénoms tahitiens gardent Te'ura.
    function capitale(s) {
      return s.toLowerCase().replace(/(^|[\s-])([a-zà-öø-ÿ])/g, function (m, p, c) { return p + c.toUpperCase(); });
    }
    // Mesure du VRAI tracé par scan de pixels sur canvas (fiable sur tous navigateurs).
    function inkScan(ch, fam) {
      var key = fam + '|' + ch; if (FONTS_OK && INK[key]) return INK[key];
      var W = 700, H = 760, bx = 200, by = 520;
      var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var c = cv.getContext('2d'); if (!c) return null;
      c.font = W_OF[fam] + ' 300px ' + fam; c.fillText(ch, bx, by);
      var d; try { d = c.getImageData(0, 0, W, H).data; } catch (e) { return null; }
      var minX = 1e9, maxX = -1, minY = 1e9, maxY = -1;
      for (var y = 0; y < H; y++) { var row = y * W; for (var x = 0; x < W; x++) { if (d[(row + x) * 4 + 3] > 40) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; } } }
      if (maxX < 0) return null;
      var r = { b: maxY - by, t: minY - by, cx: (minX + maxX) / 2 - bx, l: minX - bx, w: maxX - minX + 1, h: maxY - minY + 1 };
      if (FONTS_OK) INK[key] = r;
      return r;
    }
    var NS = 'http://www.w3.org/2000/svg';
    function mk(tag, at) { var el = document.createElementNS(NS, tag); for (var k in at) el.setAttribute(k, at[k]); return el; }

    var NG = null, LAST = null;
    function layout() {
      var nm = state.name.trim();
      var cap = capitale(nm);
      gI.textContent = initialOf(nm); gN.textContent = cap;
      [].forEach.call(root.querySelectorAll('.p3d-scripts button'), function (b) { b.textContent = cap || 'Prénom'; });
      var _ini = initialOf(nm), _f = famFor(_ini);
      gI.setAttribute('font-family', _f[0]); gI.setAttribute('font-weight', _f[1]);
      gI.setAttribute('fill', state.letter); gN.setAttribute('fill', state.nameCol);
      gN.setAttribute('font-family', state.script);
      gN.setAttribute('font-weight', state.script === 'Dancing' ? 700 : 400);
      gI.removeAttribute('transform'); gN.removeAttribute('transform');
      depthI.innerHTML = ''; depthN.innerHTML = ''; decorL.innerHTML = ''; handles.innerHTML = '';
      shadow.setAttribute('opacity', '0');
      NG = null; LAST = null;
      if (!nm) { syncForm(); return; }
      var bI = gI.getBBox();
      var frac = MEP[_ini] || 0, ink = inkScan(_ini, _f[0]);
      var tx, ty;
      if (ink) { tx = CX - ink.cx; ty = (FLOOR + frac * ink.h) - ink.b; }
      else { tx = CX - (bI.x + bI.width / 2); ty = FLOOR - (bI.y + bI.height); }
      gI.setAttribute('transform', 'translate(' + tx + ',' + ty + ')');
      // décor UV : toujours un décor unique créé à l'atelier depuis les 3 mots
      clipT.textContent = gI.textContent;
      clipT.setAttribute('font-family', _f[0]); clipT.setAttribute('font-weight', _f[1]);
      clipT.setAttribute('transform', 'translate(' + tx + ',' + ty + ')');
      if (ink) {
        var LX = tx + ink.l, LY = ty + ink.t, LW = ink.w, LH = FLOOR - LY;
        for (var yy = LY + 18; yy < LY + LH; yy += 32) for (var xx = LX + 12; xx < LX + LW; xx += 32)
          decorL.appendChild(mk('circle', { cx: xx, cy: yy, r: 2.2, fill: '#d8d3c6' }));
        var tt = mk('text', { x: LX + LW / 2, y: LY + LH / 2, 'text-anchor': 'middle', 'font-size': 22, fill: '#8a867c',
          transform: 'rotate(-16 ' + (LX + LW / 2) + ' ' + (LY + LH / 2) + ')' });
        tt.textContent = 'décor surprise ✨'; decorL.appendChild(tt);
      }
      shadow.setAttribute('cx', CX); shadow.setAttribute('rx', Math.max(70, bI.width * 0.62));
      var bN = gN.getBBox();
      if (bN.width >= 1) {
        var _p = poseFor(_ini);
        var IW = ink ? ink.w : bI.width, IH = ink ? ink.h : bI.height;
        var ITOP = ink ? (FLOOR + frac * ink.h - ink.h) : (FLOOR - bI.height);
        var s = Math.min(Math.min(VBW * 0.94, Math.max(IW * _p.wf, 230)) / bN.width * state.pn, 2.6);
        var cxN = CX + state.dx, cyN = (ITOP + (1 - _p.up) * IH) + state.dy;
        var mx = bN.x + bN.width / 2, my = bN.y + bN.height / 2;
        gN.setAttribute('transform', 'translate(' + cxN + ',' + cyN + ') scale(' + s + ') translate(' + (-mx) + ',' + (-my) + ')');
        NG = { cx: cxN, cy: cyN, s: s, bw: bN.width, bh: bN.height };
        // conversion indicative en mm pour l'atelier : 160 mm d'encre pour la lettre
        var k = ink ? 160 / ink.h : null;
        LAST = {
          initiale: _ini, police_initiale: _f[0], dx: Math.round(state.dx), dy: Math.round(state.dy), pn: +state.pn.toFixed(2),
          hauteur_prenom_mm: k ? +(120 * s * k).toFixed(1) : null,
          offset_x_mm: k ? +((cxN - CX) * k).toFixed(1) : null,
          // référence = centre de l'encre de la lettre ; y positif vers le haut comme OpenSCAD
          offset_y_mm: k ? +(((ITOP + IH / 2) - cyN) * k).toFixed(1) : null
        };
      }
      if (state.view === '3d') { extrude(gI, depthI, state.letter, 16, -0.55, 0.9); extrude(gN, depthN, state.nameCol, 4, -0.35, 0.55); }
      drawHandles(); syncForm();
    }
    function extrude(el, group, face, steps, dx, dy) {
      var side = sideColor(face), base = el.getAttribute('transform') || '';
      for (var i = steps; i >= 1; i--) {
        var c = el.cloneNode(true); c.removeAttribute('class'); c.setAttribute('fill', side);
        c.setAttribute('transform', 'translate(' + (dx * i) + ',' + (dy * i) + ') ' + base); group.appendChild(c);
      }
    }

    /* ---------- manipulation directe : glisser / poignée taille / pincer ---------- */
    function K() { return VBW / svg.getBoundingClientRect().width; }
    function pt(e) { var r = svg.getBoundingClientRect(), k = VBW / r.width; return { x: (e.clientX - r.left) * k, y: (e.clientY - r.top) * k }; }
    function clampPn(v) { return Math.max(0.35, Math.min(2.4, v)); }
    function drawHandles() {
      if (!NG || state.view === '3d') return;
      var hw = NG.s * NG.bw / 2, hh = NG.s * NG.bh / 2;
      var c0 = [NG.cx - hw, NG.cy - hh], c1 = [NG.cx + hw, NG.cy - hh], c2 = [NG.cx + hw, NG.cy + hh], c3 = [NG.cx - hw, NG.cy + hh];
      var pts = [c0, c1, c2, c3].map(function (p) { return p[0] + ',' + p[1]; }).join(' ');
      var body = mk('polygon', { points: pts, 'class': 'p3d-hbody' }); body.setAttribute('data-h', 'body'); handles.appendChild(body);
      handles.appendChild(mk('polygon', { points: pts, 'class': 'p3d-hbox' }));
      var shit = mk('circle', { cx: c2[0], cy: c2[1], r: 30, fill: 'transparent' });
      shit.setAttribute('data-h', 'resize'); shit.style.cursor = 'nwse-resize'; handles.appendChild(shit);
      handles.appendChild(mk('circle', { cx: c2[0], cy: c2[1], r: 16, 'class': 'p3d-hdot', 'pointer-events': 'none' }));
      var g = mk('g', { transform: 'translate(' + c2[0] + ',' + c2[1] + ')', 'pointer-events': 'none' });
      g.appendChild(mk('path', { d: 'M -4.6 4.6 L 4.6 -4.6', stroke: '#141414', 'stroke-width': 2.1, 'stroke-linecap': 'round', fill: 'none' }));
      g.appendChild(mk('path', { d: 'M 0.8 -5 L 5 -5 L 5 -0.8', fill: 'none', stroke: '#141414', 'stroke-width': 2.1, 'stroke-linejoin': 'round' }));
      g.appendChild(mk('path', { d: 'M -0.8 5 L -5 5 L -5 0.8', fill: 'none', stroke: '#141414', 'stroke-width': 2.1, 'stroke-linejoin': 'round' }));
      handles.appendChild(g);
    }
    var ptrs = {}, pcount = 0, mode = null, g = null;
    function pset(p) { if (!(p.pointerId in ptrs)) pcount++; ptrs[p.pointerId] = p; }
    function pdel(id) { if (id in ptrs) { delete ptrs[id]; pcount--; } }
    function two() { var a = []; for (var k in ptrs) { a.push(ptrs[k]); if (a.length === 2) break; } return a; }
    function hOf(t) { return (t && t.getAttribute) ? t.getAttribute('data-h') : null; }
    function onDown(p) {
      var hh = hOf(p.target);
      if (hh === 'resize') { if (!NG) return false; pset(p); var q = pt(p); mode = hh;
        g = { d0: Math.max(6, Math.hypot(q.x - NG.cx, q.y - NG.cy)), pn: state.pn }; return true; }
      if (hh === 'body' || p.target === gN) { pset(p);
        if (pcount >= 2) startPinch(); else { mode = 'drag'; g = { x: p.clientX, y: p.clientY, dx: state.dx, dy: state.dy }; } return true; }
      return false;
    }
    function onMove(p) {
      if (!(p.pointerId in ptrs)) return false; ptrs[p.pointerId] = p;
      if (mode === 'drag') { var k = K(); state.dx = g.dx + (p.clientX - g.x) * k; state.dy = g.dy + (p.clientY - g.y) * k; layout(); }
      else if (mode === 'resize') { var q = pt(p); state.pn = clampPn(g.pn * Math.hypot(q.x - NG.cx, q.y - NG.cy) / g.d0); layout(); }
      else if (mode === 'pinch') { var a = two(); if (a.length < 2) return true; var p0 = pt(a[0]), p1 = pt(a[1]);
        var d = Math.hypot(p1.x - p0.x, p1.y - p0.y); state.pn = clampPn(g.pn * d / g.d0);
        var mx = (p0.x + p1.x) / 2, my = (p0.y + p1.y) / 2; state.dx = g.dx + (mx - g.mx); state.dy = g.dy + (my - g.my); layout(); }
      else return false;
      return true;
    }
    function onUp(p) { pdel(p.pointerId); if (pcount < 2 && mode === 'pinch') mode = null; if (pcount === 0) mode = null; }
    function startPinch() { var a = two(); if (a.length < 2) return; var p0 = pt(a[0]), p1 = pt(a[1]); mode = 'pinch';
      g = { d0: Math.max(6, Math.hypot(p1.x - p0.x, p1.y - p0.y)), pn: state.pn, mx: (p0.x + p1.x) / 2, my: (p0.y + p1.y) / 2, dx: state.dx, dy: state.dy }; }
    function eachPt(e, fn) { var hit = false;
      if (e.changedTouches) { for (var i = 0; i < e.changedTouches.length; i++) { var t = e.changedTouches[i]; if (fn({ pointerId: 't' + t.identifier, clientX: t.clientX, clientY: t.clientY, target: e.target })) hit = true; } }
      else if (fn({ pointerId: (e.pointerId !== undefined ? e.pointerId : 'm'), clientX: e.clientX, clientY: e.clientY, target: e.target })) hit = true;
      return hit; }
    if (window.PointerEvent) {
      svg.addEventListener('pointerdown', function (e) { if (eachPt(e, onDown)) { try { svg.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); } });
      svg.addEventListener('pointermove', function (e) { if (eachPt(e, onMove)) e.preventDefault(); });
      svg.addEventListener('pointerup', function (e) { eachPt(e, onUp); });
      svg.addEventListener('pointercancel', function (e) { eachPt(e, onUp); });
    } else {
      svg.addEventListener('touchstart', function (e) { if (eachPt(e, onDown)) e.preventDefault(); }, false);
      svg.addEventListener('touchmove', function (e) { if (eachPt(e, onMove)) e.preventDefault(); }, false);
      svg.addEventListener('touchend', function (e) { eachPt(e, onUp); }, false);
      svg.addEventListener('mousedown', function (e) { if (eachPt(e, onDown)) e.preventDefault(); });
      document.addEventListener('mousemove', function (e) { eachPt(e, onMove); });
      document.addEventListener('mouseup', function (e) { eachPt(e, onUp); });
    }

    /* ---------- formulaire Shopify : propriétés de ligne + validation ---------- */
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    function setProp(name, val) {
      if (!form) return;
      var el = form.querySelector('input[name="properties[' + name + ']"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[' + name + ']'; form.appendChild(el); }
      el.value = val == null ? '' : String(val);
    }
    function syncForm() {
      var nm = capitale(state.name.trim());
      setProp('Prénom', nm);
      setProp('Initiale', initialOf(nm));
      setProp('Style d\'écriture', SCRIPT_LABEL[state.script] || state.script);
      setProp('Décor (3 mots)', state.kw.trim());
      setProp('Taille', SIZEL);
      setProp('_Placement', LAST ? JSON.stringify(LAST) : '');
    }
    function valid() {
      var nm = state.name.trim();
      if (!nm) return 'Écris d\'abord un prénom';
      if (nm.length < 2 || nm.length > 18) return 'Le prénom doit faire entre 2 et 18 caractères';
      if (!/^[A-Za-zÀ-ÿ' \-]+$/.test(nm)) return 'Le prénom ne peut contenir que des lettres, un tiret ou une apostrophe';
      if (!state.kw.trim()) return 'Donne 3 mots pour le décor de ta lettre';
      return null;
    }
    var pf = root.querySelector('product-form');
    if (pf) pf.addEventListener('submit', function (e) {
      var err = valid();
      if (err) { e.preventDefault(); e.stopPropagation(); toast(err); return; }
      syncForm();
    }, true);
    var toastEl = $('.p3d-toast'), tt;
    function toast(t) { if (!toastEl) return; toastEl.textContent = t; toastEl.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('on'); }, 3000); }

    var priceEl = $('.p3d-priceVal'); if (priceEl) priceEl.textContent = fmt(PRICE);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { FONTS_OK = true; layout(); });
    setTimeout(function () { FONTS_OK = true; layout(); }, 1500);
    layout(); setTimeout(layout, 300);
  }

  function boot() { [].forEach.call(document.querySelectorAll('.p3d[data-p3d]'), function (r) { if (!r.__p3d) { r.__p3d = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
